import i18n from 'i18n';
import { FormLabel } from '../../form-label';
import LOCALS from 'commons/locals';
import { Control, Controller } from 'react-hook-form';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import { Input } from 'antd';

const FirstValuationStockRemark = ({
  control,
  index,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
}) => {
  return (
    <div className="flex items-center gap-2">
      <FormLabel>{i18n.t(LOCALS.inventory_notes)}:</FormLabel>
      <Controller
        name={`productList.${index}.firstValuationStockRemark`}
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            placeholder={i18n.t(LOCALS.please_enter) || ''}
            maxLength={100}
            showCount
          />
        )}
      />
    </div>
  );
};

export default FirstValuationStockRemark;
